export var RoleEnum;
(function (RoleEnum) {
    RoleEnum["GOPARROT_SUPER_ADMIN"] = "goparrot_super_admin";
    RoleEnum["MERCHANT_SUPER_ADMIN"] = "merchant_super_admin";
    RoleEnum["MERCHANT_ADMIN"] = "merchant_admin";
    RoleEnum["MERCHANT_OPERATIONS"] = "merchant_operations";
    RoleEnum["MERCHANT_ANALYTICS"] = "merchant_analytics";
    RoleEnum["MERCHANT_RESEARCH"] = "merchant_research";
    RoleEnum["MERCHANT_MARKETING"] = "merchant_marketing";
    RoleEnum["STORE_ADMIN"] = "store_admin";
    RoleEnum["STORE_OPERATIONS"] = "store_operations";
    RoleEnum["GUEST_ORDERING"] = "guest_ordering";
    RoleEnum["STORE_CASHIER"] = "store_cashier";
})(RoleEnum || (RoleEnum = {}));
//# sourceMappingURL=Role.js.map